<template>
    <div>
        <!-- #region الطرف ممثل نظامي --- بيانات المنشأة -->

        <ContractEntityComponent :partner="partner" />

        <!-- #endregion -->
        <!-- #region بيانات الممثل نظامي -->

        <ContractPersonComponent :showIban="false" :showContacts="false" :partner="partner"  :parentSefa="parentSefa" />

        <!-- #endregion -->
    </div>
</template>
<script lang="ts">
    import { Component, Vue, Prop } from 'vue-property-decorator';

    import { ContractPartnerModel } from '@/models/contractPartnerModel';
    import { ContractDetails } from '@/models/contract.model';

    import ContractEntityComponent from '@/components/contract/partnerType/contract-entity.component.vue';
    import ContractPersonComponent from '@/components/contract/partnerType/contract-person.component.vue';
    @Component({
        components: {
            ContractEntityComponent,
            ContractPersonComponent
        }
    })

    export default class ContractAuthorizerComponent extends Vue {
        @Prop({ required: true }) partner!: ContractPartnerModel;
        @Prop({ required: false }) parentSefa!: number | null;
    }
</script>